import { Outlet } from 'react-router-dom';

import { DebugPanel } from '@/components/DebugPanel.js';
import { cn } from '@/lib/utils.js';

/**
 * One shell for both route trees. The Experience and Admin Console pages are
 * registered as separate base URLs in Kadanza but ship from the same Pages
 * project, so they share layout, theme and API client.
 *
 * There is deliberately no navigation or header bar here: Kadanza renders the
 * registered pages in its own sidebar and chrome, so a banner inside the iframe
 * would read as a second, competing header. The title is set at the same weight
 * as a host page title so the iframe reads as part of the host page.
 *
 * `scheme` is what scopes the dark palette to the Experience tree, which sits
 * inside the host's dark UI, while the Admin Console keeps Kadanza's light
 * chrome.
 */
export function AppShell({
  title,
  scheme = 'light',
}: {
  title: string;
  scheme?: 'light' | 'dark';
}) {
  return (
    <div
      className={cn('min-h-screen bg-page font-sans text-ink', scheme === 'dark' && 'theme-dark')}
    >
      <main className="mx-auto max-w-6xl px-6 py-10">
        <h1 className="mb-6 text-3xl font-bold tracking-tight">{title}</h1>
        <Outlet />
      </main>

      <DebugPanel />
    </div>
  );
}
